export const BASE_URL = 'https://school-book-production.up.railway.app';
